import React, { useState } from "react";
import CommonTable from "../../commonComponents/Table/table";
import { Space, Button, Modal, Pagination, Form, InputNumber, Select, Switch, message } from "antd";
import { fetchAllStudios } from "../../hooks/useStudios";
import StudioUsers from "../studioUsers";
import useLogout from "../../hooks/useLogout";
import { useQuery } from "react-query";
import SpinLoader from "../../commonComponents/SpinLoader";
import { useShipmentMutations } from "../../hooks/useStudioOps";

const AllStudio = () => {
  const [openModal, setOpenModal] = useState(false);
  const [opsOpen, setOpsOpen] = useState(false);
  const [opsForm] = Form.useForm();
  const { updateOpsConfig } = useShipmentMutations();
  const [selectedRow, setSelectedRow] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [studioList, setStudioList] = useState([]);
  const [studioData, setStudioData] = useState([]);
  const { logout } = useLogout();

  const onSuccessStudio = (data) => {
    let x = data?.data?.map((item) => {
      return {
        ...item,
        name: `${item.name}`,
        key: item._id,
        address: `${item.address.city}, ${item.address.stateOrProvince}, ${item.address.country}`,
        contact: `${item.address.contactPerson?.name} - ${item.address.contactPerson?.email}`,
      };
    });
    setStudioList(x);
    setStudioData(data);
  };
  const { isError, isFetching } = useQuery(
    ["listing", pageNumber, pageSize],
    fetchAllStudios,
    {
      refetchOnWindowFocus: false,
      select: (data) => data.data,
      onSuccess: onSuccessStudio,
    }
  );

  const columns = [
    {
      title: "Studio Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Studio Code",
      dataIndex: "code",
      keyName: "code",
    },
    {
      title: "Studio Contact Details",
      dataIndex: "contact",
      key: "contact",
    },
    {
      title: "Studio Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button onClick={() => handleAction(record)}>Users</Button>
          <Button
            onClick={() => {
              setSelectedRow(record);
              opsForm.setFieldsValue(record.operationsConfig || {});
              setOpsOpen(true);
            }}
          >
            Ops config
          </Button>
        </Space>
      ),
    },
  ];

  const handleAction = (rowData) => {
    setSelectedRow(rowData);
    setOpenModal(true);
  };

  if (isError) {
    logout();
  }

  const fetchNextData = (pageNum) => {
    let pageNo = pageNum++;
    setPageNumber(pageNo);
  };

  return (
    <>
      <div
        className="allClient-main"
        style={{
          height: "calc(100% - 108px)",
          marginTop: "60px",
          overflow: "auto",
        }}
      >
        <CommonTable
          columns={columns}
          data={studioList}
          bordered
          loading={{
            spinning: isFetching,
            indicator: <SpinLoader />,
          }}
        />

        <Modal
          open={openModal}
          onCancel={() => setOpenModal(false)}
          footer={null}
          width={800}
        >
          <StudioUsers
            title={selectedRow.name}
            handelSubmit={() => {
              alert("handelSubmit");
            }}
            id={selectedRow._id}
          ></StudioUsers>
        </Modal>
        <Modal
          open={opsOpen}
          title={`Operations config — ${selectedRow.name || ""}`}
          onCancel={() => setOpsOpen(false)}
          onOk={async () => {
            const operationsConfig = await opsForm.validateFields();
            await updateOpsConfig.mutateAsync({ studioId: selectedRow._id, operationsConfig });
            message.success("Saved");
            setOpsOpen(false);
          }}
        >
          <Form form={opsForm} layout="vertical">
            <Form.Item name="piiEnforcementMode" label="PII enforcement">
              <Select options={[{ value: "off" }, { value: "warn" }, { value: "strict" }]} />
            </Form.Item>
            <Form.Item name="auditEnforcementMode" label="Audit enforcement">
              <Select options={[{ value: "off" }, { value: "warn" }, { value: "strict" }]} />
            </Form.Item>
            <Form.Item name="approvedNoInboundHours" label="Approved no-inbound hours">
              <InputNumber min={1} />
            </Form.Item>
            <Form.Item name="segregationOfDuties" label="Segregation of duties" valuePropName="checked">
              <Switch />
            </Form.Item>
          </Form>
        </Modal>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "1rem",
        }}
      >
        <Pagination
          current={pageNumber}
          total={studioData.totalCount}
          onChange={(page) => {
            fetchNextData(page);
          }}
          pageSizeOptions={["10", "20", "50"]}
          pageSize={pageSize}
          defaultPageSize={pageSize}
          showSizeChanger
          onShowSizeChange={(current, size) => {
            setPageSize(size);
            setPageNumber(1);
          }}
        />
      </div>
    </>
  );
};

export default AllStudio;
